if (!customElements.get('bm-lazy-product-list')) {
  class LazyProductList extends HTMLElement {
    static stylesPromise;
    loading = false;
    observer;
    controller;

    connectedCallback() {
      this.parentElement.addEventListener('focusin', this.handleFocus);
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.load();
      }, { rootMargin: '900px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.parentElement?.removeEventListener('focusin', this.handleFocus);
    }

    handleFocus = () => this.load();

    loadStyles() {
      const globalStyles = document.querySelector('link[rel="stylesheet"][href*="/bm-component-styles.css"], link[rel="stylesheet"][href*="/bm-home-component-styles.css"]');
      if (globalStyles?.sheet) return Promise.resolve();
      if (!LazyProductList.stylesPromise) {
        LazyProductList.stylesPromise = new Promise((resolve, reject) => {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href = this.dataset.stylesheet;
          stylesheet.onload = resolve;
          stylesheet.onerror = () => {
            stylesheet.remove();
            LazyProductList.stylesPromise = undefined;
            reject(new Error('Product list styles could not load'));
          };
          document.head.appendChild(stylesheet);
        });
      }
      return LazyProductList.stylesPromise;
    }

    async load() {
      if (this.loading || !this.isConnected) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.sectionUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const [response] = await Promise.all([
          fetch(url, { signal: this.controller.signal, credentials: 'same-origin' }),
          this.loadStyles(),
        ]);
        if (!response.ok) throw new Error('Product list could not load');
        const html = await response.text();
        const content = new DOMParser().parseFromString(html, 'text/html');
        const list = content.querySelector('[data-testid="product-list"] .resource-list');
        if (!list) throw new Error('Product list is missing');
        await window.bmLoadModules?.(list);
        if (this.isConnected) {
          this.parentElement.removeEventListener('focusin', this.handleFocus);
          this.replaceWith(list);
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.loadError = 'true';
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('bm-lazy-product-list', LazyProductList);
}
